module.exports = __webpack_public_path__ + "static/media/4-audio.9544bd3.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/4-audio.wav
// module id = PoKX
// module chunks = 1